export type SubscriptionState = {
  steps: StepState[];
};

export type StepState = {
  url: string;
  isDefault: boolean;
  isActive: boolean;
  isCompleted: boolean;
  isAutomatic: boolean;
};

export const initialSubscriptionState: SubscriptionState = {
  steps: [],
};
